import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'timeElapsedFromNow'
})
export class TimeElapsedFromNowPipe implements PipeTransform {

  transform(date: Date, appendPostfix: boolean = false, ...args: any[]): string {
    if (!date) {
      return '';
    }
    const source = new Date(date);
    const now = new Date();
    const elapsedTime = Math.floor((now.getTime() - source.getTime()) / 1000 / 60 / 60 / 24);
    return appendPostfix ? `${elapsedTime} days` : elapsedTime.toString();
  }

}
